import { HttpHeaders } from '@angular/common/http';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, DialogService, ResponseStatus, ServiceResponse } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { TerminalTransportRegistration, TerminalTransportRegistrationResult } from '../../model/terminal/transport-registration.model';
import { PageCall } from '@sdbn/tmc-common';

export class TransportRegistrationSendDataToBackendController extends AbstractStepController {

    errorOccured = false;

    appServerAPI: AppServerAPI;

    constructor() {
        super();
        this.appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);
    }

    onContextChange(contextChange: ContextChange) {
    }

    onRegisterToDashboardContext() {
    }

    public handleFlow(): FlowStepHandleResult {
        const result = new FlowStepHandleResult();
        result.type = HandleResultType.PROCESSING;

        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('send data to backend started');

        this.saveRegistrationAndShowFinishPage();

        return result;
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();
        return controls;
    }


    private saveRegistrationAndShowFinishPage(): Promise<void> {
        this.dashboardContext.setContextValue(TerminalContextConstants.registrationFinished, new Date().getTime());
        return this.saveMasterData()
            .then(() => {
                this.saveDocuments();
            })
            .then(() => {
                // Finally call next Wizard Step
                if (!this.errorOccured) {
                    this.wizardComponent.next();
                }
            });
    }


    private saveMasterData() {

        const dto = new TerminalTransportRegistration();
        // Terminal identifier setzen
        dto.terminalIdentifier = this.dashboardContext.getContextValue('terminalIdentifier');
        dto.carrier = this.dashboardContext.getContextValue(TerminalContextConstants.carrier);
        dto.coDriver = this.dashboardContext.getContextValue(TerminalContextConstants.coDriver);
        dto.driver = this.dashboardContext.getContextValue(TerminalContextConstants.driver);
        dto.supplier = this.dashboardContext.getContextValue(TerminalContextConstants.supplier);
        dto.numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
        dto.trailerNumberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.trailerNumberPlate);
        dto.gcCaseId = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseId);
        dto.gcCaseUrl = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseUrl);
        dto.useGlobalConnect = this.dashboardContext.getContextValue('useGlobalConnect') === true;
        dto.useSms = this.dashboardContext.getContextValue('useSms') === true;
        dto.messagingLanguage = this.dashboardContext.getContextValue(TerminalContextConstants.language);
        dto.phoneNumber = this.dashboardContext.getContextValue(TerminalContextConstants.phoneNumber);
        dto.vehicleType = this.dashboardContext.getContextValue(TerminalContextConstants.vehicleType);
        dto.string1 = this.dashboardContext.getContextValue('string1');
        dto.string2 = this.dashboardContext.getContextValue('string2');

        const logContainer: LogContainer = this.dashboardContext.getContextValue(TerminalContextConstants.logContainer);

        for (const logEntry of logContainer.logEntries) {
            dto.pageCalls.push(new PageCall({ key: logEntry.message, timestamp: logEntry.timestamp }))
        }

        dto.orderReference = this.dashboardContext.getContextValue(TerminalContextConstants.orderReference);
        dto.registrationId = this.dashboardContext.getContextValue(TerminalContextConstants.registrationId);
        dto.registrationFinished = this.dashboardContext.getContextValue(TerminalContextConstants.registrationFinished);
        dto.registrationStarted = this.dashboardContext.getContextValue(TerminalContextConstants.registrationStarted);
        dto.selectedOptions = this.dashboardContext.getContextValue(TerminalContextConstants.selectedOptions);
        dto.targetStation = this.dashboardContext.getContextValue('targetStation');
        dto.smartphoneCommunicationEnabled = this.dashboardContext.getContextValue('smartphoneConnectionEnabled') === true;
        dto.smartphoneConnected = this.dashboardContext.getContextValue(TerminalContextConstants.smartphoneConnected) === true;
        dto.smartphoneRequired = this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication)
            === TerminalContextConstants.DRIVER_COMMUNICATION_LOANER;

        console.log('save master data ', dto);

        return this.appServerAPI.execute<ServiceResponse>(`/terminal/registration/finish/transport`, dto).toPromise().then(response => {
            console.log('saveMasterData call succeeded:', response);

            if (response.status === ResponseStatus.SUCCESS) {
                // We update the registrationId
                const terminalRegistrationResult = new TerminalTransportRegistrationResult(response);
                this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, terminalRegistrationResult.registrationId);
                this.dashboardContext.setContextValue(TerminalContextConstants.gatekeeperMandatory, terminalRegistrationResult.gatekeeperMandatory);
                this.dashboardContext.setContextValue(TerminalContextConstants.selectedOptions, terminalRegistrationResult.selectedOptions);
                this.dashboardContext.setContextValue(TerminalContextConstants.registrationCode, terminalRegistrationResult.registrationCode);
            } else {
                this.showHttpError();
            }

        }, error => {
            console.log('saveMasterData call failed:', error);
            this.showHttpError();
        });
    }

    private saveDocuments() {
        const captures = this.dashboardContext.getContextValue(TerminalContextConstants.captures);
        if (captures != null && captures.length > 0) {
            this.doUpload(0, this.dashboardContext.getContextValue(TerminalContextConstants.registrationId));
        }
    }

    /**
     * We have to do the uploads step-by-step, so that the server can group them together.
     */
    private doUpload(i, registrationId) {
        console.log('do upload for ', i);

        const captures = this.dashboardContext.getContextValue(TerminalContextConstants.captures);

        this.saveDocument(captures[i], i, registrationId).then(() => {
            if (i < captures.length - 1) {
                i = i + 1;
                console.log('continue with', i);
                this.doUpload(i, registrationId);
            }
        });
    }

    private saveDocument(capture: any, index: number, registrationId: number) {
        return this.appServerAPI.postFile(`/terminal/registration/upload`, capture.blob, new HttpHeaders({
            'Content-Type': 'image/jpeg',
            'Content-MD5': 'test', // TODO: Calculate MD5 hash of capture.blob
            filename: 'document-' + index + '.jpg',
            pageNumber: index.toString(),
            registrationId: registrationId.toString()
        })).toPromise().then(response => {
            console.log('saveDocument call succeeded:', response);
        }, error => {
            console.log('saveDocument call failed:', error);
            this.showHttpError();
        });
    }

    private showHttpError() {
        this.errorOccured = true;

        const matDialog = WizardServiceLocator.injector.get(DialogService);
        matDialog.showInfoDialog(
            'tmc-yard.ui.registration-terminal.registration-failed-title',
            'tmc-yard.ui.registration-terminal.registration-failed-message'
        ).afterClosed().subscribe(
            () => this.wizardComponent.restartWizard()
        );
    }

}
